<app-side-top-bar [navigationItems]="navigationItems">
  <main class="invoices-clients-page">
    <section class="clients-section">
      <div class="header">
        <div class="sections">
          <div
            class="{{ isPrivateSectionSelected ? 'selected' : 'not-selected' }}"
            (click)="togglePatientSection()"
          >
            <h2>{{ labelService.getLabel("Privati") }}</h2>
          </div>
          <div
            class="{{ isCompanySectionSelected ? 'selected' : 'not-selected' }}"
            (click)="toggleCompanySection()"
          >
            <h2>{{ labelService.getLabel("Aziende") }}</h2>
          </div>
        </div>
        <div class="header-buttons">
          <app-button
            [icon]="'add'"
            (click)="
              isPrivateSectionSelected
                ? togglePrivatePanel()
                : toggleCompanyPanel()
            "
          ></app-button>
        </div>
      </div>

      <div class="sections-container">
        @if (isCompanySectionSelected) {
          <app-invoices-company-clients
            [companyClients]="companyClients"
            [patients]="patients"
            [isLoading]="isLoadingCompanyClients"
            (togglePanel)="toggleCompanyPanel($event)"
            (deleteRequest)="deleteCompanyClient($event)"
          ></app-invoices-company-clients>
        }
        @if (isPrivateSectionSelected) {
          <app-invoices-private-clients
            [privateClients]="privateClients"
            [patients]="patients"
            [isLoading]="isLoadingPrivateClients"
            (togglePanel)="togglePrivatePanel($event)"
            (deleteRequest)="deletePrivateClient($event)"
          ></app-invoices-private-clients>
        }
      </div>
    </section>
    @if (showNewCompanyPanel) {
      <app-invoices-company-panel
        [client]="selectedCompanyClient"
        [patients]="patients"
        [newCompanyPanelTitle]="newCompanyPanelTitle"
        (createClient)="createCompanyClient($event)"
        (updateClient)="updateCompanyClient($event)"
        (closePanel)="toggleCompanyPanel()"
      ></app-invoices-company-panel>
    }
    @if (showNewPatientPanel) {
      <app-invoices-private-panel
        [client]="selectedPrivateClient"
        [patients]="patients"
        [newPatientPanelTitle]="newPatientPanelTitle"
        (closePanel)="togglePrivatePanel()"
        (createClient)="createPrivateClient($event)"
        (updateClient)="updatePrivateClient($event)"
      ></app-invoices-private-panel>
    }
  </main>
</app-side-top-bar>
